import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  public SHARED_PAYMENT_REQUESTS_HEADER_NAME = 'X-spl-token';

  private baseApiUrl = environment.apiUserWay;

  public apiUrl = {
    // TODO restore fix from Alex Melnik
    apiSSO: `${this.baseApiUrl}api/sso/v0/public/service-user/`,
    apiSSoAccount: `${this.baseApiUrl}api/sso/v0/public/service-account/`,
    apiBase: `${this.baseApiUrl}api/`,
    apiBaseV1: `${this.baseApiUrl}api/v1/`,
    apiBaseV2: `${this.baseApiUrl}api/v2/`,
    apiUserSSO: `${this.baseApiUrl}api/sso/v0/user/`,
  };

  constructor(@Inject(DOCUMENT) private document: Document) {}
}
